'use strict';

angular.module('mobile-apps').factory('MobileAppEntryStatus', [
	'$resource',
	function ($resource) {
		return $resource(
			'v1/projects/:mobileAppId',
			{
				mobileAppId: '@mobileAppId',
				languageId: '@languageId',
				groupId: '@groupId'
			},
			{
				getStatus:
				{
					method: 'POST',
					url : 'v1/projects/:mobileAppId/languages/:languageId/groups/:groupId/getStatus'
				},
				setStatus:
				{
					method: 'POST',
					url : 'v1/projects/:mobileAppId/languages/:languageId/groups/:groupId/setStatus'
				}
			}
		);
	}
]);
